{
	"backToStartPage": "Назад към началната страница",
	"transactionDetailsTitle": "Детайли за транзакцията",
	"btnVerifyTransactions": "Потвърди транзакции",
	"kpi": {
		"date": "Дата",
		"quantity": "Количество",
		"carbonReductions": "Въглеродни редукции"
	},
	"verifyTransactionModal": {
		"title": "Потвърди транзакция",
		"description": "Моля, въведете Record ID за тази транзакция. Можете да намерите информацията в декларацията.",
		"recordIdLabel": "Record ID",
		"cancelTitle": "Отказ",
		"verifyTitle": "Потвърди",
		"errors": {
			"recordIdRequired": "Record ID е задължителен",
			"recordIdInvalid": "Record ID must be 16 characters (letters or numbers), formatted like ABCD 1234 EFGH 5678",
			"verificationFailed": "Транзакцията не можа да бъде потвърдена. Моля, проверете Record ID"
		}
	},
	"errors": {
		"notFound": "Транзакцията не е намерена"
	}
}
